exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".model-doc-preview .el-dialog__header{border-color:var(--systemMainColor)!important}.model-doc-preview div.el-loading-mask,.select-tree .el-scrollbar{background-color:#0b3258!important}.el-select-dropdown{border-color:#409eff!important}", ""]);

// exports
